export enum ESignatureError {
    NO_FLOW_VALUE = 'ESIGN_NO_FLOW_VALUE',
    FLOW_VALUE_NOT_RECOGNIZED = 'ESIGN_FLOW_VALUE_NOT_RECOGNIZED',
    MISSING_PARAM = 'MISSING_PARAM',
    NO_REDIRECT_URL = 'NO_REDIRECT_URL',
    NO_STEP_VALUE = 'ESIGN_NO_STEP_VALUE',
    ACCESS_DENIED = 'ACCESS_DENIED',
}
